module.exports = __webpack_public_path__ + "static/media/1@3x.8b31eb38.png";